import { useEffect, useState } from "react";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import {
  type FilterRequestTypes,
  type FiltersRequest,
} from "shared/filter-where-clause";

export const useCustomReportFilterDefaultValues = () => {
  const { setFilters, customReportResponse, filtersRequest } =
    usePillarTableContext();

  const [hasCustomReportFilters, setHasCustomReportFilters] = useState(false);
  const reportFilters = customReportResponse?.filtersConfig ?? [];

  const hasActiveFilters = Object.values(filtersRequest).some(
    (filterValue) =>
      filterValue !== "" && filterValue !== null && filterValue !== undefined,
  );

  const assignFilterDateRangeValue = (
    acc: FiltersRequest,
    key: string,
    value: FilterRequestTypes | FiltersRequest,
  ) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      // Date range defaults carry the request keys they populate
      // (`<filterKey>-from` / `<filterKey>-to`), so merge them in as-is.
      Object.assign(acc, value);
    } else {
      acc[key] = value as FilterRequestTypes;
    }
  };

  useEffect(() => {
    if (reportFilters.length === 0 || hasCustomReportFilters) {
      return;
    }

    setHasCustomReportFilters(true);

    if (hasActiveFilters) {
      return;
    }

    const defaultFilterValues = reportFilters.reduce<FiltersRequest>(
      (acc, { filterKey, component }) => {
        const { defaultValue } = component ?? {};

        if (!filterKey || defaultValue === undefined) {
          return acc;
        }

        assignFilterDateRangeValue(acc, filterKey, defaultValue);

        return acc;
      },
      {},
    );

    if (Object.keys(defaultFilterValues).length) {
      setFilters(defaultFilterValues);
    }
  }, [reportFilters.length]);

  return { hasCustomReportFilters };
};
